import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import api from '../utils/api';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    const cachedUserData = localStorage.getItem('userData');
    try {
      return cachedUserData ? JSON.parse(cachedUserData) : null;
    } catch (error) {
      console.error('Error parsing userData from localStorage:', error);
      localStorage.removeItem('userData'); // Clear invalid data
      return null;
    }
  });

  const [loading, setLoading] = useState(!userData); // Skip loading if cached data exists

  useEffect(() => {
    const fetchUserData = async () => {
      if (!userData) {
        setLoading(true);
        try {
          const response = await api.get('/users/me'); // Adjust API endpoint if necessary
          setUserData(response.data);
          localStorage.setItem('userData', JSON.stringify(response.data)); // Cache user data
        } catch (error) {
          console.error('Error fetching user data:', error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [userData]);

  const refreshUserData = async () => {
    setLoading(true);
    try {
      const response = await api.get('/users/me');
      setUserData(response.data);
      localStorage.setItem('userData', JSON.stringify(response.data)); // Update cache
    } catch (error) {
      console.error('Error refreshing user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const value = useMemo(() => ({ userData, loading, setUserData, refreshUserData }), [userData, loading]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
